<div [formGroup]="creditForm">
    <div fxLayout="row wrap" fxLayoutAlign="start center">
      <mat-form-field appearance="outline" class="input-form" fxFlex="30" fxFlex.lt-md="100">
        <mat-label>クレ企業コード</mat-label>
        <mat-select
          formControlName="crdcomCoCode"
          autocomplete="off"
          (ngModelChange)="changeCrdcoCodeNm()"
        >
          <mat-option value="" selected></mat-option>
          <mat-option
            *ngFor="let code of codeCreComAnameList"
            [value]="code.value"
          >{{ code.value }}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div fxLayout="row wrap" fxLayoutAlign="start center">
      <mat-form-field appearance="fill" class="input-form" fxFlex="30" fxFlex.lt-md="100">
        <mat-label>クレ企業名</mat-label>
        <input matInput
          formControlName="crdcoCodeNm"
          class="font-color-display-only"
          readonly
        />
      </mat-form-field>
    </div>
    <div fxLayout="row wrap" fxLayoutAlign="start center">
      <mat-form-field appearance="outline" class="input-form" fxFlex="30" fxFlex.lt-md="100">
        <mat-label>カード名義（カナ）</mat-label>
        <input matInput
          formControlName="cardMeigiKana"
          autocomplete="off"/>
      </mat-form-field>
    </div>
    <div fxLayout="row wrap" fxLayoutAlign="start center">
      <mat-form-field appearance="outline" class="input-form" fxFlex="30" fxFlex.lt-md="100">
        <mat-label>DBキー</mat-label>
        <input matInput
          formControlName="crdLinkKey"
          autocomplete="off"/>
      </mat-form-field>
    </div>
  </div>